import propTypes from 'prop-types';
import { Button, Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const PostFooterBar = ({ item }) => {
  const navigate = useNavigate();

  return (
    <>
      <hr className="divider-solid" />
      <div className="d-flex justify-content-between mb-5" id='postNavFooter'>
        <a
          href="https://www.instagram.com/no_manejes/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Image
            className="post-p d-inline-block"
            src="/images/blog/assets/instagram_logo.svg"
            alt="instagram logo"
            width="35"
            height="35"
            style={{ cursor: 'pointer', marginBottom: '0' }}></Image>
        </a>

        <Button
          key={item.id}
          className="post-p-small  text-decoration-none"
          variant="link"
          style={{ cursor: 'pointer' }}
          onClick={() => navigate(item.url)} ><strong>{item.title}</strong></Button>
      </div>
    </>
  )
};

export default PostFooterBar;

PostFooterBar.propTypes = {
  item: propTypes.shape({
    id: propTypes.number.isRequired,
    title: propTypes.string.isRequired,
    url: propTypes.string.isRequired
  }).isRequired
}